import React, { useState, useEffect } from "react";
import { SearchBar, SideBar, TabsComponent } from "./SubComponents";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { tabsOptions } from "./Constants";
import CustomerStationFaults from "./CustomerStationFaults";
import CustomerTrainFaults from "./CustomerTrainFaults";
import { cloneDeep } from "lodash";
import CustomerSuggestion from "./CustomerSuggestion";
import { getAllReports } from "../../actions/reports";
import { Loader } from "../Utils/Loader";
import { clearReportState } from "../../actions/reports";
import "../../stylesheets/Document.css";

const Document = (props) => {
  const [searchText, setSearchText] = useState("");
  const [allReport, setAllReports] = useState({
    liveFault: [],
    archiveFaults: [],
  });
  const [selectedTab, setTabs] = React.useState({
    id: 1,
    title: "Customer Station Faults",
    icon: "cfacility-fault-icon",
    url: "customerfacilityfault",
  });

  const [archieveData, setArchieveData] = useState({
    is_archive: 0,
    reportId: "",
  });

  const history = useHistory();
  const dispath = useDispatch();
  const params = useParams();
  const getAllReportData = useSelector((state) => state.reportReducers);
  const getProfileData = useSelector((state) => state.profileReducer);
  const userData = useSelector((state) => state.usersReducers);
  const { loader, modalLoader } = useSelector((state) => state.HeaderReducer);
  let tab =
    params.type === "customerfacilityfault"
      ? "cff"
      : params.type === "customertrainfault"
      ? "ctf"
      : "cs";

  // useEffect(() => {
  //   dispath(clearReportState())
  // }, [params.type])

  useEffect(() => {
    dispath(getAllReports({ tab, email: getProfileData.email }));

    if (params.type == "customerfacilityfault") {
      setTabs(tabsOptions[0]);
    } else if (params.type == "customertrainfault") {
      setTabs(tabsOptions[1]);
    } else {
      setTabs(tabsOptions[2]);
    }
  }, [tab]);

  useEffect(() => {
    let allReportTemp = cloneDeep(allReport);
    if (
      getAllReportData &&
      Object.keys(getAllReportData.allReports).length > 0 &&
      getAllReportData.allReports
    ) {
      allReportTemp.liveFault = getAllReportData.allReports.pageData.filter(
        (el) => el.is_archive === 0
      );
      allReportTemp.archiveFaults = getAllReportData.allReports.pageData.filter(
        (el) => el.is_archive === 1
      );
      setAllReports(allReportTemp);
      // setIsFetching(false)
    }
  }, [getAllReportData.allReports]);

  useEffect(() => {
    if (allReport.liveFault.length > 0) {
      let archieveDataTemp = cloneDeep(archieveData);

      if (history.location.state) {
        if (history.location.state.reportId) {
          let findReport =
            getAllReportData?.allReports &&
            getAllReportData?.allReports?.pageData &&
            getAllReportData?.allReports?.pageData.find(
              (el) => el.id == history.location.state.reportId
            );
          archieveDataTemp.reportId = findReport && findReport.id;
          archieveDataTemp.selectedReportName = findReport && findReport.name;
          archieveDataTemp.is_archive = history.location.state.isArchive;
        } else {
          archieveDataTemp.is_archive = history.location.state.isArchive;
          archieveDataTemp.reportId =
            allReport[
              archieveDataTemp.is_archive == 1 ? "archiveFaults" : "liveFault"
            ][0].id;
          archieveDataTemp.selectedReportName = allReport.liveFault[0].name;
        }
      } else {
        archieveDataTemp.reportId = allReport.liveFault[0].id;
        archieveDataTemp.selectedReportName = allReport.liveFault[0].name;
      }
      setArchieveData(archieveDataTemp);
    }
  }, [allReport.liveFault]);

  const searchHandler = (searchText) => {
    setSearchText(searchText);
  };

  const addReportHandler = (type) => {
    if (history) {
      let activeTab = selectedTab && selectedTab.url;
      history.push(`/FaultReporter/admin/reports/${activeTab}/add/${type}`);
    }
  };

  // const editReportHandler = (type) => {
  //   if (history) history.push(`/FaultReporter/admin/reports/edit`);
  // };

  const tabsHandler = (tab) => {
    setTabs(tab);
    dispath(clearReportState());
    let archieveDataTemp = cloneDeep(archieveData);
    archieveDataTemp.reportId = "";
    archieveDataTemp.is_archive = 0;
    setArchieveData(archieveDataTemp);
    setSearchText("");
    if (history) history.push(`/FaultReporter/admin/${tab.url}`);
  };

  const onReportFiltersHander = (selectedFilter) => {
    let archieveDataTemp = cloneDeep(archieveData);
    archieveDataTemp.reportId = selectedFilter.id;
    archieveDataTemp.selectedReportName = selectedFilter.name;
    setSearchText("");
    setArchieveData(archieveDataTemp);
  };

  const getSideBarArcheiveData = (data) => {
    setSearchText("");
    setArchieveData(data);
  };

  if (
    !userData.isAuthorized ||
    userData.roleID === 0 ||
    userData.roleID === 2
  ) {
    return loader ? (
      <Loader />
    ) : (
      <div className="not-page">User Not Authorized</div>
    );
  } else if (
    userData.isAuthorized &&
    (userData.roleID === 3 || userData.roleID === 4 || userData.roleID === 5)
  ) {
    return (
      <>
        <SearchBar searchHandler={searchHandler} searchText={searchText} />
        <div className="bodySectn">
          <TabsComponent
            tabsOptions={tabsOptions}
            selectedTab={selectedTab}
            tabsHandler={tabsHandler}
            userData={userData}
          />
          <div className="navigationSectn">
            <SideBar
              selectedTab={selectedTab}
              selectedFilter={archieveData}
              reportsData={allReport}
              addReportHandler={addReportHandler}
              onFiltersHander={onReportFiltersHander}
              getSideBarArcheiveData={getSideBarArcheiveData}
              archieveDataObj={archieveData}
            />
            <div className="rightNavStn">
              {params.type === "customerfacilityfault" &&
              userData.userCF === 1 ? (
                <CustomerStationFaults
                  modalLoader={modalLoader}
                  searchText={searchText}
                  archieveData={archieveData}
                  // selectedRow={selectedRow}
                />
              ) : params.type === "customertrainfault" &&
                userData.userCT === 1 ? (
                <CustomerTrainFaults
                  modalLoader={modalLoader}
                  searchText={searchText}
                  archieveData={archieveData}
                />
              ) : params.type === "suggestions" && userData.userCS === 1 ? (
                <CustomerSuggestion
                  searchText={searchText}
                  archieveData={archieveData}
                />
              ) : typeof userData.userCS == "number" ? (
                <div className="fault-history">
                  <div className="no-user">
                    <i className="zmdi zmdi-block"></i>No faults to display for
                    this user.
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default Document;
